import React, { FC, useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'stores/hooks/hooks';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import { TabViewTabChangeEvent } from 'primereact/tabview';
import api from 'Api/ApiMethods';
import { NotificationTemplate } from 'models/restTypes';
import NotificationTemplateTable from './NotificationTemplateTable';
import MenuBar from './MenuBar';

const Container = styled(Grid)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
`;

const StyledMarginGrid = styled(Grid)`
  margin: 1rem 1rem 0 1rem;
  width: 100%;
`;

const TabViewContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 1rem;
`;

enum TemplateTabs {
  Template = 0,
}

const Templates: FC = observer(() => {
  const { notificationStore } = useStores();

  const [loading, setLoading] = useState<boolean>(false);
  const [activeIndex, setActiveIndex] = useState<TemplateTabs>(
    TemplateTabs.Template,
  );

  const onTabChange = useCallback((e: TabViewTabChangeEvent) => {
    setActiveIndex(e.index);
  }, []);

  useEffect(() => {
    setLoading(true);
    notificationStore.getAllNotificationTemplates().then(() => {
      setLoading(false);
    });

    return () => {
      notificationStore.resetNotificationTemplates();
    };
  }, [notificationStore]);

  return (
    <Container>
      <StyledMarginGrid align="stretch">
        <MenuBar selectedTab={activeIndex} />
        <NotificationTemplateTable
          templates={notificationStore.notificationTemplates}
          isLoading={loading}
        />
      </StyledMarginGrid>
    </Container>
  );
});

export default Templates;
